/** Canonical Z-Cars body types (value, label). */
export const VEHICLE_BODY_TYPES = [
  ["sedan", "Sedan"],
  ["suv", "SUV"],
  ["hatchback", "Hatchback"],
  ["crossover", "Crossover"],
  ["coupe", "Coupe"],
  ["van", "Van"],
  ["pickup_truck", "Pickup"],
  ["convertible", "Convertible"],
];

/** Deprecated browse/search slugs → canonical body type. */
export const LEGACY_VEHICLE_TYPE_REDIRECTS = {
  sports: "coupe",
  luxury: "sedan",
  electric: "sedan",
  economy: "sedan",
  compact: "hatchback",
};

const CANONICAL_VALUES = new Set(VEHICLE_BODY_TYPES.map(([v]) => v));

/** Normalize a vehicle_type query param or filter value. */
export function resolveVehicleType(slug) {
  if (!slug) return "";
  const mapped = LEGACY_VEHICLE_TYPE_REDIRECTS[slug] || slug;
  return CANONICAL_VALUES.has(mapped) ? mapped : "";
}
